import { render, staticRenderFns } from "./AutocompleteClass.vue?vue&type=template&id=2378fbf6"
import script from "./AutocompleteClass.vue?vue&type=script&lang=js"
export * from "./AutocompleteClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports